import { BrandsEnum } from '@seb/web-design-system/core';

import { wcTefalConfig } from './config/brands/wc.tefal.config';
import { wcMoulinexConfig } from './config/brands/wc.moulinex.config';
import { wcKrupsConfig } from './config/brands/wc.krups.config';
import { wcRowentaConfig } from './config/brands/wc.rowenta.config';
import { wcCalorConfig } from './config/brands/wc.calor.config';
import { wcSebConfig } from './config/brands/wc.seb.config';
import { WcConfig } from './models/wc-config.model';

const webCommonConfig: Record<BrandsEnum, WcConfig> = {
  [BrandsEnum.moulinex]: wcMoulinexConfig,
  [BrandsEnum.tefal]: wcTefalConfig,
  [BrandsEnum.krups]: wcKrupsConfig,
  [BrandsEnum.rowenta]: wcRowentaConfig,
  [BrandsEnum.calor]: wcCalorConfig,
  [BrandsEnum.seb]: wcSebConfig,
  [BrandsEnum.hob]: undefined,
  [BrandsEnum.default]: undefined
};

export function getBrandConfig(brand: BrandsEnum): WcConfig {
  return webCommonConfig[brand];
}
